var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttemptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91 17.1794C3.72 17.1794 3.53 17.1094 3.38 16.9594C2.01 15.5794 1.25 13.7594 1.25 11.8294C1.25 7.81944 4.5 4.55944 8.5 4.55944L14.57 4.57944L13.48 3.53944C13.18 3.24944 13.17 2.77944 13.46 2.47944C13.75 2.17944 14.22 2.16944 14.52 2.45944L16.96 4.79944C17.18 5.00944 17.25 5.33944 17.14 5.61944C17.03 5.89944 16.75 6.08944 16.44 6.08944L8.5 6.06944C5.33 6.06944 2.75 8.65944 2.75 11.8394C2.75 13.3694 3.35 14.8194 4.44 15.9094C4.73 16.1994 4.73 16.6794 4.44 16.9694C4.29 17.1094 4.1 17.1794 3.91 17.1794Z",
    fill: "#017EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 21.75C9.8099 21.75 9.6299 21.68 9.4799 21.54L7.0399 19.2C6.8199 18.99 6.7499 18.66 6.8599 18.38C6.9699 18.1 7.2499 17.91 7.5599 17.91L15.5099 17.93C18.6799 17.93 21.2599 15.34 21.2599 12.16C21.2599 10.63 20.6599 9.18 19.5699 8.09C19.2799 7.8 19.2799 7.32 19.5699 7.03C19.8599 6.74 20.3399 6.74 20.6299 7.03C21.9999 8.41 22.7599 10.23 22.7599 12.16C22.7599 16.17 19.5099 19.43 15.5099 19.43L9.4399 19.41L10.5299 20.45C10.8299 20.74 10.8399 21.21 10.5499 21.51C10.3899 21.67 10.1999 21.75 9.9999 21.75Z",
    fill: "#017EA7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5H15C16.92 15.5 18.5 13.93 18.5 12C18.5 10.08 16.93 8.5 15 8.5H9C7.08 8.5 5.5 10.07 5.5 12C5.5 13.93 7.07 15.5 9 15.5Z",
    fill: "#017EA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttemptIcon);
export default __webpack_public_path__ + "static/media/attemptIcon.e674f97326466473d432946541b9f3cf.svg";
export { ForwardRef as ReactComponent };